import { render, staticRenderFns } from "./DictRadioGroup.vue?vue&type=template&id=0a34a515&scoped=true&"
import script from "./DictRadioGroup.vue?vue&type=script&lang=js&"
export * from "./DictRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34a515",
  null
  
)

export default component.exports